import {
  CHANGE_AVAILABILITY_BLOCKS,
  CHANGE_AVAILABILITY_BLOCKS_APPOINTMENT_TYPE,
  CLOSE_DIALOG_AVAILABILITY_BLOCKS,
  OPEN_DIALOG_AVAILABILITY_BLOCKS,
} from './constants';

export function closeDialogAvailabilityBlocks() {
  return {
    type: CLOSE_DIALOG_AVAILABILITY_BLOCKS,
  };
}

export function openDialogAvailabilityBlocks() {
  return {
    type: OPEN_DIALOG_AVAILABILITY_BLOCKS,
  };
}

export function changeAvailabilityBlocks(availabilityBlocks) {
  return {
    type: CHANGE_AVAILABILITY_BLOCKS,
    availabilityBlocks,
  };
}

export function changeAvailabilityBlocksAppointmentType(availabilityBlocks) {
  return {
    type: CHANGE_AVAILABILITY_BLOCKS_APPOINTMENT_TYPE,
    availabilityBlocks,
  };
}
